<template>
  <v-card height="100%">
    <div class="pt-6 mr-2">
      <v-card flat>
        <v-row class="d-flex justify-space-between padding-bottom ml-2">
          <div>
            <v-btn
                depressed
                color="primary"
                v-on:click="back()"
            >
              返回
            </v-btn>
          </div>
        </v-row>
        <v-row class="mt-10">
          <v-col cols="auto" class="text-right"><label class="red--text pl-12">*</label> 班次: </v-col>
          <v-col cols="11">
            <v-row><v-col cols="1"><v-btn outlined small color="blue-grey" @click="addShift" v-if="_hasButtonPermission('添加班次')">添加</v-btn></v-col></v-row>
            <v-row>
              <v-col cols="12">
                <v-card outlined tile height="150px" style="overflow-y: scroll">
                  <v-simple-table dense>
                    <template v-slot:default>
                      <tbody>
                        <tr v-for="shift in shiftList">
                          <td style="border-bottom: 0">{{ shift.shiftName }}</td>
                          <td style="border-bottom: 0">{{ shift.shiftTimeList.join(',') }}</td>
                          <td class="text-right" style="border-bottom: 0">
                            <v-btn text small color="blue-grey" @click="editShift(shift)" v-if="_hasButtonPermission('添加班次')">编辑</v-btn>
                            <v-btn text small color="blue-grey" @click="deleteShift(shift)" v-if="_hasButtonPermission('添加班次')">删除</v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="mt-10">
          <v-col cols="auto" class="text-right"><label class="red--text pl-6">*</label> 排班设置: </v-col>
          <v-col cols="11">
            <v-card outlined tile>
              <v-card
                  class="d-flex justify-space-between my-3"
                  flat
                  tile
              >
                <div class="ml-2">
                  <v-btn outlined small color="blue-grey" class="mr-2" @click="tableToExcel('shiftPersonTable','排班')" v-if="_hasButtonPermission('导出排班')">导出排班</v-btn>
                  <v-btn outlined small color="blue-grey" @click="importDialog = true" v-if="_hasButtonPermission('导入排班')">导入排班</v-btn>
                </div>
                <div class="text-center blue-grey--text">
                  <v-btn text small color="blue-grey" @click="subMonth">< </v-btn>
                  <label>{{ year }}年{{ month+1 }}月</label>
                  <v-btn text small color="blue-grey" @click="plusMonth">> </v-btn>
                </div>
                <div>
                  <v-btn text small color="blue-grey" @click="tableToExcel('templateTable','排班模板')" v-if="_hasButtonPermission('导入排班')">下载模板 </v-btn>
                  <v-btn outlined small color="blue-grey" class="mr-2" @click="currentMonth">本月</v-btn>
                  <v-btn outlined small color="blue-grey" class="mr-2" @click="copyShiftPerson" v-if="_hasButtonPermission('导入排班')">复制上月排班</v-btn>
                </div>
              </v-card>
            </v-card>
            <v-card outlined tile>
              <v-simple-table dense >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <td></td>
                      <td v-for="day in dayList">
                        {{day.date}}<br/>{{day.week}}
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="person in personList">
                      <td style="min-width: 90px">{{person.userName}}</td>
                      <td v-for="day in dayList">
                        {{shiftPersonList[person.userId + '_' + day.date]?shiftPersonList[person.userId + '_' + day.date].shiftName:'休'}}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
      <v-dialog persistent v-model="shiftDialog" width="950">
        <v-card>
          <v-card-title>
            {{shiftTitle}}
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form ref="shiftForm">
                <v-row align="center">
                  <v-col cols="2" class="text-right"><label>班次名称:</label></v-col>
                  <v-col cols="6"><v-text-field outlined dense v-model="shift.shiftName" :rules="[rules.required]"></v-text-field></v-col>
                </v-row>
                <v-row align="center" v-for="(time, i) in shift.timeList">
                  <v-col cols="2" class="text-right"><label v-if="i==0">打卡时间:</label></v-col>
                  <v-col cols="1" class="text-right"><label> 上班 </label></v-col>
                  <v-col cols="3"><v-text-field outlined dense v-model="time.startTime" :rules="[rules.required]"></v-text-field></v-col>
                  <v-col cols="1" class="text-right"><label> - 下班 </label></v-col>
                  <v-col cols="3"><v-text-field outlined dense v-model="time.endTime" :rules="[rules.required]"></v-text-field></v-col>
                  <v-col cols="2">
                    <v-btn small fab elevation="0" v-if="i>0" class="mr-2" @click="subShiftTime(i)"><v-icon small>mdi-minus</v-icon></v-btn>
                    <v-btn small fab elevation="0" v-if="i==shift.timeList.length-1" @click="plusShiftTime"><v-icon small>mdi-plus</v-icon></v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="saveShift"> 保存 </v-btn>
            <v-btn text @click="shiftDialog = false"> 取消 </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="importDialog" width="950">
        <v-card>
          <v-card-title>
            导入
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form ref="importForm">
                <v-row align="center">
                  <v-col cols="2" class="text-right"><label>导入年月:</label></v-col>
                  <v-col cols="4"><date-picker label="" type="month" v-model="importMonth" :rules="[rules.required]"></date-picker></v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="2" class="text-right"><label>文件:</label></v-col>
                  <v-col cols="6"><v-file-input
                      truncate-length="15"
                      label=""
                      small-chips
                      dense
                      v-model="importFile"
                      :rules="[rules.required]"
                  ></v-file-input></v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="handleImport"> 上传 </v-btn>
            <v-btn text @click="hideImport"> 取消 </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <div id="shiftPersonTable" style="display: none">
        <table >
          <thead>
            <tr>
              <td :colspan="dayList.length + 1" style="background-color: paleturquoise ; text-align: center; font-weight: bold">{{year}}{{pad(month+1,2)}}排班表</td>
            </tr>
            <tr>
              <td :colspan="dayList.length + 1" style="background-color: paleturquoise; text-align: center"><label v-for="shift in shiftList">{{shift.shiftName}}:{{ shift.shiftTimeList.join(',') }};</label>休息 （只能按现有班次排班，否则无法识别。班次信息只能在企业微信后台修改）</td>
            </tr>
            <tr >
              <td :rowspan="2" style="background-color: palegreen">姓名</td>
              <td v-for="day in dayList" style="background-color: palegreen">周{{day.week}}</td>
            </tr>
            <tr>
              <td v-for="day in dayList" style="background-color: palegreen">{{day.date}}</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="person in personList">
              <td>{{person.userName}}</td>
              <td v-for="day in dayList">{{shiftPersonList[person.userId + '_' + day.date]?shiftPersonList[person.userId + '_' + day.date].shiftName:'休'}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div id="templateTable" style="display: none" >
        <table >
          <thead>
          <tr>
            <td :colspan="dayList.length + 1" style="background-color: paleturquoise ; text-align: center; font-weight: bold; border: thin solid black">{{year}}{{pad(month+1,2)}}排班表</td>
          </tr>
          <tr>
            <td :colspan="dayList.length + 1" style="background-color: paleturquoise; text-align: center; border: thin solid black"><label v-for="shift in shiftList">{{shift.shiftName}}:{{ shift.shiftTimeList.join(',') }};</label>休息 （只能按现有班次排班，否则无法识别。班次信息只能在企业微信后台修改）</td>
          </tr>
          <tr >
            <td :rowspan="2" style="background-color: palegreen; border:thin solid black">姓名</td>
            <td v-for="day in dayList" style="background-color: palegreen; border: thin solid black">周{{day.week}}</td>
          </tr>
          <tr>
            <td v-for="day in dayList" style="background-color: palegreen; border: thin solid black">{{day.date}}</td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="person in personList">
            <td style="border: thin solid black">{{person.userName}}</td>
            <td v-for="day in dayList" style="border: thin solid black"></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </v-card>
</template>

<script>
import SchedulingApi from "@/api/pd/inspection/SchedulingApi";
import BudgetEditionApi from "@/api/pd/budget/BudgetEdition";

// import FileSaver from 'file-saver';
// import XLSX2 from 'xlsx';
// import XLSX from 'xlsx-style';

export default {
  name: "Detail",
  // components: {
  //   FileSaver,
  //   XLSX2,
  //   XLSX
  // },
  props: {
    shopId: [Number, String],
    buttonPriviledgeList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      rules:{
        required: value => (!!value || value === 0) || '必填.',
      },
      shiftList:[],
      shiftDialog:false,
      shiftTitle:null,
      shift:{},

      year:new Date().getFullYear(),
      month:new Date().getMonth(),
      dayList:[],
      personList:[],
      shiftPersonList:{},

      importDialog:false,
      importMonth:'',
      importFile:null,
    }
  },
  mounted() {
    this.getShiftList();
    let date = new Date(this.year, this.month,1);
    this.getEveryDay(date, this.month);
  },
  methods: {
    back() {
      this.$emit("back")
    },
    plusMonth(){
      let date = new Date(this.year, this.month,1);
      date.setMonth(this.month + 1);
      this.year = date.getFullYear();
      this.month = date.getMonth();
      this.getEveryDay(date,date.getMonth());
    },
    subMonth(){
      let date = new Date(this.year, this.month,1);
      date.setMonth(this.month - 1);
      this.year = date.getFullYear();
      this.month = date.getMonth();
      this.getEveryDay(date,date.getMonth());
    },
    currentMonth(){
      this.year = new Date().getFullYear();
      this.month = new Date().getMonth()
      let date = new Date(this.year, this.month,1);
      this.getEveryDay(date,date.getMonth());
    },
    getEveryDay(date, month) {
      this.dayList = [];
      console.log(date);
      date.setMonth(month + 1);
      date.setDate(0);
      let day = date.getDate();
      for(let i = 1; i <= day; i++){
        date.setDate(i);
        this.dayList.push({
          key:i,
          date:i,
          week:['日','一','二','三','四','五','六'][date.getDay()]
        })
      }
      this.listShiftPerson();
    },
    async getShiftList() {
      let queryUserResp = await SchedulingApi.listShiftShop({
        shopId: this.shopId
      });
      let data = queryUserResp.data;
      if (!data || !data.code || data.code != 200) {
        let msg = data.msg;
        msg = !msg || msg == "" ? "获取班次列表失败" : msg;
        throw new Error(msg);
      }
      if (!data.data) {
        throw new Error("获取班次列表情况失败(无会话数据)");
      }
      let shiftList = data.data;
      shiftList.forEach(shift=>{
        let timeList = [];
        let shiftTimeList = JSON.parse(shift.shiftTime);
        shiftTimeList.forEach(shiftTime=>{
          let times = shiftTime.split('-');
          timeList.push({startTime:times[0],endTime:times[1]});
        })
        shift.timeList = timeList;
        shift.shiftTimeList = shiftTimeList;
      });
      this.shiftList = shiftList;
    },
    addShift(){
      this.shift = {shiftName:'',timeList:[{startTime:'',endTime:''}]};
      this.shiftTitle = "添加";
      this.shiftDialog = true;
    },
    plusShiftTime(){
      this.shift.timeList.push({startTime:'',endTime:''});
    },
    subShiftTime(index){
      this.shift.timeList.splice(index,1);
    },
    async saveShift() {
      let formValid = this.$refs.shiftForm.validate();
      if (formValid) {
        let shift = this.shift;
        let shiftTime = [];
        this.shift.timeList.forEach(time => {
          shiftTime.push(time.startTime + '-' + time.endTime);
        })
        shift.shiftTime = JSON.stringify(shiftTime);
        shift.shiftCode = shift.shiftName;
        shift.shopId = this.shopId;

        let queryUserResp = await SchedulingApi.saveShiftShop(shift);
        let data = queryUserResp.data;
        if (!data || !data.code || data.code != 200) {
          let msg = data.msg;
          msg = !msg || msg == "" ? "保存班次失败" : msg;
          throw new Error(msg);
        }
        this.getShiftList();
        this.shiftDialog = false;
      }
    },
    editShift(shift){
      this.shift = Object.assign({},shift);
      this.shiftTitle = "编辑";
      this.shiftDialog = true;
    },
    async deleteShift(shift) {
      let confirm = await this.$dialog.confirm({
        text: "删除后，已被安排该班次的员工将无法按照该班执行任务，在周期中也会被删除，需重新设置，确认继续？",
        title: "提示",
      });
      if(confirm){
        let queryUserResp = await SchedulingApi.deleteShiftShop(shift.id);
        let data = queryUserResp.data;
        if (!data || !data.code || data.code != 200) {
          let msg = data.msg;
          msg = !msg || msg == "" ? "删除班次失败" : msg;
          throw new Error(msg);
        }
        this.getShiftList();
      }
    },
    async listShiftPerson() {
      let queryUserResp = await SchedulingApi.listShiftPerson({
        shopId: this.shopId,
        year:this.year,
        month:this.month + 1,
      });
      let data = queryUserResp.data;
      if (!data || !data.code || data.code != 200) {
        let msg = data.msg;
        msg = !msg || msg == "" ? "获取排班记录失败" : msg;
        throw new Error(msg);
      }
      if (!data.data) {
        throw new Error("获取排班记录情况失败(无会话数据)");
      }
      this.personList = data.data.personList;

      let shiftPersonList = data.data.shiftPersonList;
      let shiftPersonData = {};
      shiftPersonList.forEach(shiftPerson=>{
        shiftPersonData[shiftPerson.userId + '_' + shiftPerson.day] = {shiftId:shiftPerson.shiftId, shiftName:shiftPerson.shiftName};
      })
      this.shiftPersonList = shiftPersonData;
    },

    tableToExcel(tableid, fileName) {
      require.ensure([], () => {
        const { export_table_to_excel } = require('@/util/Export2Excel')    //引入
        export_table_to_excel(tableid, fileName)            //传参调用
      })
    },
    pad(num, n) {
      var len = num.toString().length;
      while(len < n) {
        num = "0" + num;
        len++;
      }
      return num;
    },
    async handleImport() {
      let formValid = this.$refs.importForm.validate();
      if (formValid) {
        let me = this;
        let file = me.importFile;

        if (!file || !file.size) {
          me.$dialog.error({
            text: "文件必传",
            title: "操作失败",
          });
          return;
        }
        let res = await SchedulingApi.importData({yearMonth:this.importMonth, shopId:this.shopId},file);
        console.log("导入结果", res);
        if (res.data.code === 200) {
          if(res.data.data){
            me.$dialog.error({
              text: res.data.data,
              title: "操作失败",
            });
          }else{
            me.$dialog.info({
              text: res.data.msg,
              title: "操作成功",
            });
          }
          me.listShiftPerson();
          me.hideImport();
        } else {
          me.$dialog.error({
            text: res.data.msg + ':' + res.data.msg_detail,
            title: "操作失败",
          });
        }
      }
    },
    hideImport(){
      this.importMonth = "";
      this.importFile = null;
      this.importDialog = false;
    },
    async copyShiftPerson() {
      let confirm = await this.$dialog.confirm({
        text: "复制将会覆盖之前导入的数据，确认复制？",
        title: "提示",
      });
      if(confirm){
        let res = await SchedulingApi.copyShiftPerson({shopId:this.shopId, year:this.year, month:this.month + 1});
        if (res.data.code === 200) {
          if(res.data.data){
            this.$dialog.error({
              text: res.data.data,
              title: "操作失败",
            });
          }else{
            this.$dialog.info({
              text: res.data.msg,
              title: "操作成功",
            });
          }
          this.listShiftPerson();
        } else {
          this.$dialog.error({
            text: res.data.msg + ':' + res.data.msg_detail,
            title: "操作失败",
          });
        }
      }
    },
    _hasButtonPermission(name) {
      let buttonPriviledgeList = this.buttonPriviledgeList;
      let hasButton = false;
      for (let i = 0; i < buttonPriviledgeList.length; i++) {
        if (buttonPriviledgeList[i].name == name) {
          if (buttonPriviledgeList[i].hasPriviledge == "Y") {
            return true;
          } else {
            return false;
          }
        }
      }
      return false;
    },
  }
}
</script>

<style scoped>
</style>